import createReducer from '../utils/createReducer';
import actionTypes from './actionTypes';
import type { SiteLoadSuccessProps, SiteState } from '../../types';

const defaultState: SiteState = {
  siteName: '',
};

export default createReducer(defaultState)({
  [actionTypes.SITE_LOAD_SUCCESS]: (
    state: SiteState,
    action: { siteData: SiteLoadSuccessProps }
  ) => ({
    ...state,
    siteName: action.siteData.siteName,
  }),
});
